import React, { useEffect, useState , useCallback } from "react";
import DataTable from "react-data-table-component";
import "react-data-table-component-extensions/dist/index.css";
import {
  get_course_term_data,
  course_lecthure_details_destroy,
  course_homework_details_destroy,
} from "../../apis/Course";
import ShowAllToggle, { rowActive } from "./ShowAllToggle";
import { fitActionColumn } from "../../Utils/actionColumn";
import { Link } from "react-router-dom";
const NestedExpandedComponent = ({ data }) => {
  const [courseTermData, setCourseTermData] = useState([]);
  const fetchData = async () => {
    const res = await get_course_term_data(data?.course_id, data?.id);
    setCourseTermData(res?.data);
  };
  useEffect(() => {
    fetchData();
  }, [data]);
  let globalIndex = 0;
  const destroyLecture = async (course_id, term_id, subject_id, unit_id) => {
    const result = window.confirm("Are you sure you want to delete this?");
    if (result) {
      await course_lecthure_details_destroy(
        course_id,
        term_id,
        subject_id,
        unit_id
      );
    }
    fetchData();
  };
  const destroyHowework = async (
    course_id,
    term_id,
    subject_id,
    unit_id,
    skill
  ) => {
    const result = window.confirm("Are you sure you want to delete this?");
    if (result) {
      await course_homework_details_destroy(
        course_id,
        term_id,
        subject_id,
        unit_id,
        skill
      );
    }
    fetchData();
  };

  return (
    <div>
      <br />
      <h5>Lectures </h5>
      <table className="table table-bordered">
        <thead>
          <tr>
            <th>No</th>
            <th>Subject</th>
            <th>Name</th>
            <th>Unit</th>
            <th>Action</th>
            <th>Play</th>
          </tr>
        </thead>
        <tbody>
          {courseTermData &&
            courseTermData?.lectures?.map((elem, i) => {
              // console.log('lecthure Data',elem);

              return (
                <tr>
                  <td>{i + 1}</td>
                  <td>{elem?.subject ? elem?.subject : "-"}</td>
                  <td>{elem?.name ? elem?.name : "-"}</td>
                  <td>{elem?.unit_id ? elem?.unit_id : "-"}</td>
                  <td>
                    {" "}
                    <Link
                      className="edit-btn"
                      to={`/admin/course-managment/course/edit/${elem?.course_id}/${elem?.term_id}/${elem?.course_type_id}/${elem?.grade_id}/${elem?.year}`}
                      onClick={() => {
                        localStorage.setItem(
                          "courseSubjectID",
                          parseInt(elem?.subject_id)
                        );
                        localStorage.setItem("CourseEditType", "term");
                      }}
                      state={{
                        currentStepActive: 2,
                        isNotVisibleFirstStep: true,
                      }}
                    >
                      <i class="fa fa-pencil" aria-hidden="true"></i>
                    </Link>{" "}
                    <button
                      className="dlt-btn"
                      onClick={() =>
                        destroyLecture(
                          elem?.course_id,
                          elem?.term_id,
                          elem?.subject_id,
                          elem?.unit_id
                        )
                      }
                    >
                      {" "}
                      <i class="fa fa-trash" aria-hidden="true"></i>
                    </button>
                  </td>
                  <td>
                    {" "}
                    {elem?.units
                      ?.filter((item) => item.abbreviation)
                      .map((item, index) => (
                        <a
                          key={index}
                          href={item.file_path || "#"}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ marginRight: 5 }}
                        >
                          {item.abbreviation}
                        </a>
                      ))
                      .reduce(
                        (prev, curr) => (prev ? [prev, " | ", curr] : [curr]),
                        null
                      )}
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>
      <h5>Home Work </h5>
      <table className="table table-bordered">
        <thead>
          <tr>
            <th>No</th>
            <th>Subject</th>
            <th>Skill</th>
            <th>Unit</th>
            <th>TSTM GUID</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {courseTermData &&
            courseTermData?.homeworks?.map((elem, i) => {
              if (!elem?.units || elem?.units.length === 0) {
                return (
                  <tr key={++globalIndex}>
                    <td>{globalIndex}</td>
                    <td>{elem?.subject ? elem?.subject : "-"}</td>
                    <td>-</td>
                    <td>{elem?.unit_id ? elem?.unit_id : "-"}</td>
                    <td>-</td>
                    <td>
                      {" "}
                      <Link
                        className="edit-btn"
                        to={`/admin/course-managment/course/edit/${elem?.course_id}/${elem?.term_id}/${elem?.course_type_id}/${elem?.grade_id}`}
                        onClick={() => {
                          localStorage.setItem(
                            "courseSubjectID",
                            parseInt(elem?.subject_id)
                          );
                          localStorage.setItem("CourseEditType", "term");
                        }}
                        state={{
                          currentStepActive: 2,
                          learningStepActive: 3,
                          isNotVisibleFirstStep: true,
                        }}
                      >
                        <i class="fa fa-pencil" aria-hidden="true"></i>
                      </Link>{" "}
                      <button
                        className="dlt-btn"
                        onClick={() =>
                          destroyHowework(
                            elem?.course_id,
                            elem?.term_id,
                            elem?.subject_id,
                            elem?.unit_id
                          )
                        }
                      >
                        {" "}
                        <i class="fa fa-trash" aria-hidden="true"></i>
                      </button>
                    </td>
                  </tr>
                );
              } else {
                return elem?.units.map((item) => (
                  <tr key={`${globalIndex}`}>
                    <td>{++globalIndex}</td>
                    <td>{elem?.subject ? elem?.subject : "-"}</td>
                    <td>{item?.abbreviation ? item?.abbreviation : "-"}</td>
                    <td>{elem?.unit_id ? elem?.unit_id : "-"}</td>
                    <td>{item?.tstm_guid ? item?.tstm_guid : "-"}</td>
                    <td>
                      {" "}
                      <Link
                        className="edit-btn"
                        to={`/admin/course-managment/course/edit/${elem?.course_id}/${elem?.term_id}/${elem?.course_type_id}/${elem?.grade_id}/${elem?.year}`}
                        onClick={() => {
                          localStorage.setItem(
                            "courseSubjectID",
                            parseInt(elem?.subject_id)
                          );
                          localStorage.setItem("CourseEditType", "term");
                        }}
                        state={{
                          currentStepActive: 2,
                          learningStepActive: 3,
                          isNotVisibleFirstStep: true,
                        }}
                      >
                        <i class="fa fa-pencil" aria-hidden="true"></i>
                      </Link>{" "}
                      <button
                        className="dlt-btn"
                        onClick={() =>
                          destroyHowework(
                            elem?.course_id,
                            elem?.term_id,
                            elem?.subject_id,
                            elem?.unit_id,
                            item?.skill
                          )
                        }
                      >
                        {" "}
                        <i class="fa fa-trash" aria-hidden="true"></i>
                      </button>
                    </td>
                  </tr>
                ));
              }
            })}
        </tbody>
      </table>
    </div>
  );
};

const CustomTableWithChild = ({ columns, data, childColumns, type ,  search, isAllActiveFilterNotReq, disableInternalSort  }) => {
  const [searchData, setSearchData] = useState("");
  // Lists open with active rows only; "Show all" adds the inactive ones.
  const [showAll, setShowAll] = useState(false);
  // Offer the switch only when the rows carry a status to filter on.
  const canFilter = isAllActiveFilterNotReq !== true && (data || []).some((row) => rowActive(row) !== null);
  // inactive rows out of view while the list shows active ones only
  const hiddenCount = canFilter && !showAll ? data.filter((row) => rowActive(row) === false).length : 0;


  const isDataInRow = (rowData)=>{
    //if (!value) return allData; // If no value, return all data immediately
    const lowerCaseValue = searchData.toLowerCase();
  return Object.keys(rowData).some((k) =>
    String(rowData[k]).toLowerCase().includes(lowerCaseValue)
  )
}
  const onSearch = useCallback((value, sortByKey = "asc", allData, isActiveDataOnly) => {
    if(!isActiveDataOnly && !searchData ){
      return allData
    }
    let BothFilters =  isActiveDataOnly && searchData 
    // a row with no status of its own stays in the active list
    const searchRes = allData.filter((o) =>
      BothFilters ? rowActive(o) !== false && isDataInRow(o)
           :isActiveDataOnly ? rowActive(o) !== false : isDataInRow(o)
    );
    if (disableInternalSort) return searchRes;
    const sortedData = searchRes.sort((a, b) => {
      const aValue = a[sortByKey]?.toLowerCase();
      const bValue = b[sortByKey]?.toLowerCase();
      if (aValue < bValue) return -1;
      if (aValue > bValue) return 1;
      return 0;
    });
    return sortedData;
  }, [data, searchData , showAll, disableInternalSort]);

  const customStyles = {
    table: { style: { tableLayout: "fixed" } },
    headRow: { style: { backgroundColor: "#f1f1f1", color: "#333", fontSize: "13px", minHeight: "36px" } },
    headCells: { style: { paddingLeft: "8px", paddingRight: "8px", paddingTop: "6px", paddingBottom: "6px", fontWeight: "bold", fontSize: "13px" } },
    rows: { style: { minHeight: "32px", paddingTop: "0px", paddingBottom: "0px", fontSize: "13px", backgroundColor: "#fff", "&:nth-child(odd)": { backgroundColor: "#f9f9f9" } } },
    cells: { style: { paddingTop: "4px", paddingBottom: "4px", paddingLeft: "8px", paddingRight: "8px" } },
    pagination: { style: { minHeight: "40px", fontSize: "13px" } },
  };

  const childCompactStyles = {
    headRow: { style: { backgroundColor: "#f8f9fa", minHeight: "30px", borderBottom: "1px solid #e9ecef" } },
    headCells: { style: { paddingLeft: "10px", paddingRight: "10px", paddingTop: "4px", paddingBottom: "4px", fontWeight: "600", fontSize: "11px", color: "#888", textTransform: "uppercase", letterSpacing: "0.3px" } },
    rows: { style: { minHeight: "34px", fontSize: "12px", backgroundColor: "#fff", borderBottom: "1px solid #f0f0f0", "&:hover": { backgroundColor: "#f8fafc" } } },
    cells: { style: { paddingTop: "4px", paddingBottom: "4px", paddingLeft: "10px", paddingRight: "10px" } },
  };

  const ExpandedComponent = ({ data }) => {
    return type === "class" ? (
      <div style={{
        margin: "0 0 0 32px", padding: "10px 16px 10px 16px",
        borderLeft: "3px solid #3b82f6", background: "#fafbfc",
        borderRadius: "0 0 6px 6px",
      }}>
        <div style={{ fontSize: 11, fontWeight: 500, color: "#999", marginBottom: 6, textTransform: "uppercase", letterSpacing: "0.5px" }}>
          Students ({data.terms?.length || 0})
        </div>
        <div style={{ borderRadius: 6, overflow: "hidden", border: "1px solid #e9ecef" }}>
          <DataTable
            noHeader
            columns={fitActionColumn(childColumns, data.terms)}
            data={data.terms}
            defaultSortField="id"
            customStyles={childCompactStyles}
            dense
          />
        </div>
      </div>
    ) : (
      <div className="p-4">
        <DataTable
          noHeader
          columns={fitActionColumn(childColumns, data.terms)}
          data={data.terms}
          defaultSortField="id"
          expandableRows
          expandableRowsComponent={({ data }) => (
            <NestedExpandedComponent data={data} />
          )}
        />
      </div>
    );
  };

  return (
    <>
     <div className="searc-bar">
          <div className="row">
          {search === false? "": <div className={ "col-md-6"}>
              <input
                type="search"
                className="form-control  float-end"
                placeholder="Search here..."
                value={searchData}
                onChange={(e) => setSearchData(e.target.value)}
              />
            </div>
            }
            {/* {searchData &&
        <div onClick={()=>setSeacrhData('')}><i class="fa-solid fa-xmark"></i></div>
       } */}
            
            { canFilter ? <div className="col-md-6 text-end">
                <ShowAllToggle checked={showAll} onChange={setShowAll} hidden={hiddenCount} />
              </div> : ""}
            
          </div>
        </div>
      
      <DataTable
      className="table_text_b"
        noHeader
        columns={fitActionColumn(columns, data)}
        data={data?.length > 0  ?onSearch(searchData,"name" , data , canFilter && !showAll):data}
        defaultSortField="id"
        defaultSortAsc={true}
        pagination
        paginationPerPage={20}
        sortMode="multiple"
        highlightOnHover
        expandableRows
        expandOnRowClicked
        expandableRowsComponent={ExpandedComponent}
        customStyles={customStyles}
      />
    </>
  );
};

export default CustomTableWithChild;
